<template>
  <div class="occupancy-product">
    <div class="occupancy-product__wrap">
      <span class="mr-1">Per</span>
      <occupancy-icons
        v-b-popover.hover.top="create_icons.tooltip"
        :occupancy="create_icons"
      />
      <vb-icon
        v-b-popover.hover.top="create_icons.tooltip"
        :name="'info'"
        :color="sass('gray-500')"
        :size="13"
        class="occupancy-product__icon occupancy-product__icon--info ml-1"
      />
    </div>
    <span
      v-if="create_icons.free_stay_message"
      class="occupancy-product__alert"
    >
      {{ create_icons.free_stay_message }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format_product_occupancy } from '@bookingv3/utilities'
import OccupancyIcons from '@bookingv3/components/atoms/occupancy_icons'

export default {
  name: 'occupancy-product',

  components: {
    'occupancy-icons': OccupancyIcons,
  },

  data() {
    return {}
  },

  props: {
    id: String,
    maximum_occupancy: Object,
  },

  computed: {
    ...mapState({
      // stato del modulo livebkv3
      occupancy: state => state.livebkv3.selected_solution.occupancy
    }),

    /**
     * Occupancy effettiva del prodotto (vedi `format_product_occupancy`) con il
     * tooltip descrittivo, es. "capienza massima di questa soluzione: 2 adulti
     * e 2 bambini di 3 e 7 anni".
     */
    create_icons() {
      const occupancy = format_product_occupancy(this.maximum_occupancy, this.occupancy)
      const tooltip = `capienza massima di questa soluzione: ${occupancy.guests}`

      this.$emit('badge-tooltip', this.id, tooltip)

      return {
        adults: occupancy.adults,
        children: occupancy.children,
        children_free: occupancy.children_free,
        free_stay_message: occupancy.free_stay_message,
        tooltip
      }
    }
  },

  methods: {},
}
</script>

<style lang="scss" scoped>

  .occupancy-product {
    $this_occupancy: &;

    &__wrap {
      display: flex;
      align-items: center;
    }

    &__alert {
      font-size: $font-size-sm;
      margin-bottom: 0;
    }
  }

</style>